
import { defineComponent } from "vue";
import  UserList  from "./UserList.vue"

export default defineComponent({
    name: "UserRoute",
    components: { 
        UserList
    }
});
